import React from 'react'

function Icon({active = '#202020'}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill={active}
        fillOpacity="0.5"
        d="M3.333 14.667A.667.667 0 012.667 14V2a.667.667 0 01.666-.667h9.334a.667.667 0 01.666.667v2H12V2.667H4v10.666h8V12h1.333v2a.667.667 0 01-.666.667H3.333zm8.667-4v-2H7.333V7.333H12v-2L15.333 8 12 10.667z"
      ></path>
    </svg>
  )
}

export default Icon
